import { Button } from "@material-ui/core";
import React from "react";

class FallbackComponent extends React.Component {
  downloadTxtFile = () => {
    const element = document.createElement("a");
    const file = new Blob([this.props.errorStack], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = `ErrorReport-Dexter web-${new Date().toUTCString()}.txt`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };
  render() {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 50,
          top: 200,
          position: "absolute",
          zIndex: 400,
          color: "#e2146e",
        }}
      >
        Something went wrong !
        <Button
          onClick={this.downloadTxtFile}
          style={{
            fontSize: 18,
            textTransform: "none",
            border: "1px solid #e2146e",
          }}
        >
          Download error report
        </Button>
      </div>
    );
  }
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorStack: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    this.setState({ errorStack: error.toString() + info.componentStack });
    //console.clear();
    console.log(error);
    console.log(info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <FallbackComponent errorStack={this.state.errorStack} />;
    }

    return this.props.children;
  }
}
